import { useState } from 'react'

import OrganizationDetails from '@/components/company/OrganizationDetails'
import Configuration from '@/components/company/Configuration'
import DataCalculation from '@/components/company/DataCalculation'
import CronLogs from '@/components/company/CronLogs'
import ExpenseRatioPanel from '@/components/company/ExpenseRatioPanel'
import LeavePolicy from '@/components/company/LeavePolicy'
import { useCheckPermission } from '@/hooks/useCheckPermission'

export default function Settings() {
  const { hasPageAccess } = useCheckPermission()
  const [activeTab, setActiveTab] = useState<
    'company' | 'datascope' | 'expense' | 'clickup' | 'logs' | 'leave'
  >('company')

  return (
    <div className='bg-background h-full flex flex-col overflow-hidden p-8 space-y-6 font-sans text-foreground'>
      <div className='flex-1 flex flex-col mx-auto w-full space-y-10 overflow-hidden'>
        <div className='flex shrink-0'>
          <div className='flex p-1 bg-muted border border-border rounded-xl gap-1 overflow-x-auto scrollbar-none'>
            {(
              [
                { key: 'company', label: 'Company Profile' },
                { key: 'datascope', label: 'Data Calculation & Scope' },
                { key: 'expense', label: 'Expense Ratio' },
                { key: 'clickup', label: 'ClickUp Configuration' },
                { key: 'logs', label: 'Sync History' },
                ...(hasPageAccess('employees')
                  ? [{ key: 'leave', label: 'Leave Policy' } as const]
                  : []),
              ] as const
            ).map(({ key, label }) => (
              <button
                key={key}
                onClick={() => setActiveTab(key)}
                className={`px-4 py-1.5 text-xs font-medium transition-all duration-200 rounded-lg whitespace-nowrap ${
                  activeTab === key
                    ? 'bg-primary text-primary-foreground shadow-sm'
                    : 'text-muted-foreground hover:text-foreground hover:bg-white/5'
                }`}
              >
                {label}
              </button>
            ))}
          </div>
        </div>

        <div className='flex-1 overflow-auto w-full'>
          {activeTab === 'company' && <OrganizationDetails />}
          {activeTab === 'datascope' && <DataCalculation />}
          {activeTab === 'expense' && <ExpenseRatioPanel />}
          {activeTab === 'clickup' && <Configuration />}
          {activeTab === 'logs' && <CronLogs />}
          {activeTab === 'leave' && <LeavePolicy />}
        </div>
      </div>
    </div>
  )
}
